/* 
Modulo de enrutado, para ir a las diversas páginas
 */

import React from "react";

//REDUX
import { useSelector } from "react-redux";

//Componentes
import PersistentDrawerLeft from "../components/PersistentDrawerLeft";
import FullWidthTabs from "../components/FullWidthTabs";

//CSS
import Hidden from "@material-ui/core/Hidden";

export default function Header() {
  
  

  const user = useSelector(state => state.user);

  return (
    <div>
      {!user || user.isLogged ?
      <React.Fragment>
      <Hidden smDown>
        <FullWidthTabs></FullWidthTabs>
      </Hidden>
      <Hidden smUp>
        <PersistentDrawerLeft></PersistentDrawerLeft>
      </Hidden>
      </React.Fragment>
      :null}
    </div>
  );
}

